var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHuf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 100 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_1310",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 75
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H94C97.3137 0 100 2.68629 100 6V69C100 72.3137 97.3137 75 94 75H6C2.68629 75 0 72.3137 0 69V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_1310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 0H0V25.0063H100V0Z",
    fill: "#B2151B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 25.0063H0V50.0031H100V25.0063Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 50.0031H0V75H100V50.0031Z",
    fill: "#1F9400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 0C97.3137 0 100 2.68629 100 6V69C100 72.3137 97.3137 75 94 75H6C2.68629 75 0 72.3137 0 69V6C0 2.68629 2.68629 0 6 0H94ZM6 6V69H94V6H6Z",
    fill: "black",
    fillOpacity: 0.08
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuf);
export default __webpack_public_path__ + "static/media/HUF.30a3b360486ff3a74d06031bf8dd2b19.svg";
export { ForwardRef as ReactComponent };